import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "title-text" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fields" }
const _hoisted_4 = {
  key: 0,
  class: "oldest"
}
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = { class: "fields" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.photos.length > 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " [" + _toDisplayString(_ctx.t('memories', 'Newest')) + "] ", 1))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.longDateStr) + " " + _toDisplayString(_ctx.newestDirty ? '*' : ''), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NcTextField, {
        class: "field",
        type: "number",
        min: "0",
        max: "5000",
        modelValue: _ctx.year,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
        label: _ctx.t('memories', 'Year'),
        "label-visible": true,
        placeholder: _ctx.t('memories', 'Year'),
        disabled: _ctx.disabled,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newestChange())),
        onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
      }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
      _createVNode(_component_NcTextField, {
        class: "field",
        type: "number",
        min: "1",
        max: "12",
        modelValue: _ctx.month,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.month) = $event)),
        label: _ctx.t('memories', 'Month'),
        "label-visible": true,
        placeholder: _ctx.t('memories', 'Month'),
        disabled: _ctx.disabled,
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.newestChange())),
        onKeypress: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
      }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
      _createVNode(_component_NcTextField, {
        class: "field",
        type: "number",
        min: "1",
        max: "31",
        modelValue: _ctx.day,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.day) = $event)),
        label: _ctx.t('memories', 'Day'),
        "label-visible": true,
        placeholder: _ctx.t('memories', 'Day'),
        disabled: _ctx.disabled,
        onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.newestChange())),
        onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
      }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
      _createVNode(_component_NcTextField, {
        class: "field",
        type: "number",
        min: "0",
        max: "23",
        modelValue: _ctx.hour,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.hour) = $event)),
        label: _ctx.t('memories', 'Hour'),
        "label-visible": true,
        placeholder: _ctx.t('memories', 'Hour'),
        disabled: _ctx.disabled,
        onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.newestChange(true))),
        onKeypress: _cache[11] || (_cache[11] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
      }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
      _createVNode(_component_NcTextField, {
        class: "field",
        type: "number",
        min: "0",
        max: "59",
        modelValue: _ctx.minute,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.minute) = $event)),
        label: _ctx.t('memories', 'Minute'),
        placeholder: _ctx.t('memories', 'Minute'),
        disabled: _ctx.disabled,
        onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.newestChange(true))),
        onKeypress: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
      }, null, 8, ["modelValue", "label", "placeholder", "disabled"])
    ]),
    (_ctx.photos.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, " [" + _toDisplayString(_ctx.t('memories', 'Oldest')) + "] ", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.longDateStrLast) + " " + _toDisplayString(_ctx.oldestDirty ? '*' : ''), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NcTextField, {
              class: "field",
              type: "number",
              min: "0",
              max: "5000",
              modelValue: _ctx.yearLast,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.yearLast) = $event)),
              label: _ctx.t('memories', 'Year'),
              "label-visible": true,
              placeholder: _ctx.t('memories', 'Year'),
              disabled: _ctx.disabled,
              onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.oldestChange())),
              onKeypress: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
            _createVNode(_component_NcTextField, {
              class: "field",
              type: "number",
              min: "1",
              max: "12",
              modelValue: _ctx.monthLast,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.monthLast) = $event)),
              label: _ctx.t('memories', 'Month'),
              "label-visible": true,
              placeholder: _ctx.t('memories', 'Month'),
              disabled: _ctx.disabled,
              onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.oldestChange())),
              onKeypress: _cache[20] || (_cache[20] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
            _createVNode(_component_NcTextField, {
              class: "field",
              type: "number",
              min: "1",
              max: "31",
              modelValue: _ctx.dayLast,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dayLast) = $event)),
              label: _ctx.t('memories', 'Day'),
              "label-visible": true,
              placeholder: _ctx.t('memories', 'Day'),
              disabled: _ctx.disabled,
              onInput: _cache[22] || (_cache[22] = ($event: any) => (_ctx.oldestChange())),
              onKeypress: _cache[23] || (_cache[23] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
            _createVNode(_component_NcTextField, {
              class: "field",
              type: "number",
              min: "0",
              max: "23",
              modelValue: _ctx.hourLast,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.hourLast) = $event)),
              label: _ctx.t('memories', 'Hour'),
              "label-visible": true,
              placeholder: _ctx.t('memories', 'Hour'),
              disabled: _ctx.disabled,
              onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.oldestChange())),
              onKeypress: _cache[26] || (_cache[26] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder", "disabled"]),
            _createVNode(_component_NcTextField, {
              class: "field",
              type: "number",
              min: "0",
              max: "59",
              modelValue: _ctx.minuteLast,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.minuteLast) = $event)),
              label: _ctx.t('memories', 'Minute'),
              placeholder: _ctx.t('memories', 'Minute'),
              disabled: _ctx.disabled,
              onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.oldestChange())),
              onKeypress: _cache[29] || (_cache[29] = _withKeys(($event: any) => (_ctx.$emit('save')), ["enter"]))
            }, null, 8, ["modelValue", "label", "placeholder", "disabled"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}